const plumnoteTermsData = {
  title: "Plumnote — Terms of Service",
  updated: "Last updated: 28 September 2026",
  intro:
    "Plumnote is a private notebook for writing and organising notes and to-dos while you browse. The floating panel, the notebook page, the popup, the web clipper and page notes are all ways to reach the same notes, stored on your device (and, only if you turn it on, in your own Google Drive — see the Privacy Policy).",
  sections: [
    {
      heading: "Your responsibility",
      list: [
        "You are responsible for what you write, save and clip. Clip only for personal use, respect copyright and the terms of the websites you use, and do not use Plumnote to store or share unlawful content.",
        "Plumnote is not directed at children under 13.",
      ],
    },
    {
      heading: "No warranty",
      paragraphs: [
        "Plumnote is provided \"as is\", without warranty of any kind. To the maximum extent permitted by law, the author is not liable for data loss or any damages arising from its use. Nothing here limits your statutory consumer rights.",
      ],
    },
    {
      heading: "Donations",
      paragraphs: [
        "Donations are voluntary gifts. They are non-refundable and do not buy features, support or any service — Plumnote is fully free for everyone. Blockchain transactions are public by nature.",
      ],
    },
    {
      heading: "Other pages and trademarks",
      paragraphs: [
        "Links to external pages (the Chrome Web Store, the developer's website) open sites with their own terms and privacy policies. Plumnote is not affiliated with or endorsed by Google. Chrome is a trademark of Google LLC.",
      ],
    },
    {
      heading: "Accessibility",
      paragraphs: [
        "Plumnote aims to meet WCAG 2.2 AA. If something is hard to use, please tell us via the Contact page.",
      ],
    },
    {
      heading: "Changes",
      paragraphs: [
        "If these terms change, the new version will be published here with a new date.",
      ],
    },
  ],
  btnBack: "Back",
};

export default plumnoteTermsData;
